import { IAutoMappingCombiningTargetFormation } from '../../interfaces/iauto-mapping-combining-target-formation';
import { Area } from '../area';
import { Scenario } from '../scenario';
import { TargetFormation } from '../target-formation';

export class AutoMappingCombiningTargetFormationBase {
  AutoMappingCombiningTargetFormationId: number;
  ScenarioId: number;
  AreaId: number;
  TargetFormationId: number;
  CombiningTargetFormationId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  Scenario?: Scenario;
  TargetFormation?: TargetFormation;
  CombiningTargetFormation?: TargetFormation;

  constructor(item?: IAutoMappingCombiningTargetFormation) {
    if (item) {

      this.AutoMappingCombiningTargetFormationId = item.AutoMappingCombiningTargetFormationId;
      this.ScenarioId = item.ScenarioId;
      this.AreaId = item.AreaId;
      this.TargetFormationId = item.TargetFormationId;
      this.CombiningTargetFormationId = item.CombiningTargetFormationId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.Scenario = new Scenario(item.Scenario);
      this.TargetFormation = new TargetFormation(item.TargetFormation);
      this.CombiningTargetFormation = new TargetFormation(item.CombiningTargetFormation);
    }
  }
}